/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamEvaluationResultData } from './genericApiResponseOralExamEvaluationResultData';
import type { GenericApiResponseOralExamEvaluationResultMessage } from './genericApiResponseOralExamEvaluationResultMessage';
import type { GenericApiResponseOralExamEvaluationResultPagination } from './genericApiResponseOralExamEvaluationResultPagination';
import type { GenericApiResponseOralExamEvaluationResultError } from './genericApiResponseOralExamEvaluationResultError';

export interface GenericApiResponseOralExamEvaluationResult {
  data?: GenericApiResponseOralExamEvaluationResultData;
  message?: GenericApiResponseOralExamEvaluationResultMessage;
  pagination?: GenericApiResponseOralExamEvaluationResultPagination;
  error?: GenericApiResponseOralExamEvaluationResultError;
  statusCode?: number;
}
